import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "items", "view", "getItemAttributes", "getItemIcon", "getItemLabel", "getItemOnClick", "getItemIsLogo", "getItemTagName", "theme", "onItemClick"];
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { cnTheme } from '@carnica/themes';
import styles from "./styles.pcss";
import { composePreparedProps } from "./utils";
import { MenuItem } from "./MenuItem";
var cnMenu = cnBem('menu', styles);
var MenuRender = function MenuRender(props, ref) {
  var _composePreparedProps = composePreparedProps(props),
    className = _composePreparedProps.className,
    items = _composePreparedProps.items,
    _composePreparedProps2 = _composePreparedProps.view,
    view = _composePreparedProps2 === void 0 ? 'accent' : _composePreparedProps2,
    getItemAttributes = _composePreparedProps.getItemAttributes,
    getItemIcon = _composePreparedProps.getItemIcon,
    getItemLabel = _composePreparedProps.getItemLabel,
    getItemOnClick = _composePreparedProps.getItemOnClick,
    getItemIsLogo = _composePreparedProps.getItemIsLogo,
    getItemTagName = _composePreparedProps.getItemTagName,
    _composePreparedProps3 = _composePreparedProps.theme,
    theme = _composePreparedProps3 === void 0 ? 'light' : _composePreparedProps3,
    onItemClick = _composePreparedProps.onItemClick,
    otherProps = _objectWithoutProperties(_composePreparedProps, _excluded);
  return /*#__PURE__*/React.createElement("ul", _extends({
    className: cnMenu({
      view: view
    }, [className, cnTheme(theme)]),
    ref: ref
  }, otherProps), items.map(function (item) {
    var _getItemAttributes;
    return /*#__PURE__*/React.createElement("li", {
      className: cnMenu('item'),
      key: getItemLabel(item)
    }, /*#__PURE__*/React.createElement(MenuItem, _extends({}, (_getItemAttributes = getItemAttributes(item)) !== null && _getItemAttributes !== void 0 ? _getItemAttributes : {}, {
      icon: getItemIcon(item),
      isLogo: getItemIsLogo(item),
      label: getItemLabel(item),
      onClick: getItemOnClick(item),
      tagName: getItemTagName(item),
      theme: theme,
      view: view
    })));
  }));
};
export var Menu = /*#__PURE__*/forwardRef(MenuRender);